import { EXISTING } from './SelectPartyStep';

import isNil from 'lodash/isNil';
import i18n from '../../../../i18n/i18n';

const validate = values => {
  let errors = {};

  if (!values.buyer) {
    errors.buyer = i18n.t('createContract:validate.buyerSelect');
  }
  if (!values.seller) {
    errors.seller = i18n.t('createContract:validate.sellerSelect');
  }
  if (!values.skus || Object.keys(values.skus).length === 0) {
    errors.skus = i18n.t('createContract:validate.skuSelect');
  }
  if (!values.contractName) {
    errors.contractName = i18n.t('createContract:validate.contractName');
  }
  if (!values.pricingContractType) {
    errors.pricingContractType = i18n.t('createContract:validate.pricingContractTypeSelect');
  }
  if (values.creationType === EXISTING && isNil(values.selectedContract)) {
    errors.selectedContract = i18n.t('createContract:validate.creationTypeSelect');
  }

  return errors;
};

export default validate;
